// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__23Q_C","navText":"Navbar_navText__3bGHH","navLogo":"Navbar_navLogo__2vbVR","imgLogo":"Navbar_imgLogo__XOYgB"};